import { candleParser } from '../candleParser';

/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645477257290,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","candle":{"high":100.0,"low":100.0,"open":100.0,"close":100.0,"candleSymbol":"XYZ","candleStartTimeStamp":1641133860000,"duration":"1min"}},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"CONVICTION_CANDLE","symbol":"XYZ"},
	"date": "2022-02-21T16:00:57.933-0500",
	"timestamp": "1645477257936"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 */
export function convictionCandleParser(pluginTemplate) {
  const parsedObject = {
    candleDuration: null,
    timeUnit: null,
    candle: null,
  };
  if (pluginTemplate) {
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
